import {
  mergeClasses,
  Slider,
} from '@fluentui/react-components';
import React from 'react';
import { useStyles } from './style';
import type { ScrubberProps } from '../types';

const DELTA_DIVISOR = 20; // 20 gives 5% delta

export const Scrubber = ({
  usePlayerTime,
  usePlayerControls,
}: ScrubberProps) => {
  const classes = useStyles();
  const time = usePlayerTime();
  const { seek, duration, seekDelta } = usePlayerControls();
  const delta = duration / DELTA_DIVISOR;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'ArrowLeft') {
      seekDelta(-delta);
    } else if (event.key === 'ArrowRight') {
      seekDelta(delta);
    }
  };

  const handleOnChange = (_: unknown, data: { value: number }) => {
    seek(data.value);
  };

  return (
    <Slider
      value={time}
      max={duration}
      onChange={handleOnChange}
      min={0}
      thumb={{
              className: mergeClasses('scrubber-thumb', classes.scrubberThumb),
          }}
      rail={{
              className: mergeClasses('scrubber-rail', classes.scrubberRail),
          }}
      className={mergeClasses(classes.scrubber, 'clipchamp-player-scrubber')}
      aria-valuetext={`${time} seconds of ${duration} seconds`}
      size="medium"
      onKeyDown={handleKeyDown}
    />
  );
};
